// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-gradient-card-cover[data-v-3f41ce58]:after{background:radial-gradient(circle at 5% 95%,rgba(99,81,61,.5) 0,transparent 80%),radial-gradient(circle at 5% 95%,rgba(99,81,61,.4) 0,transparent 30%);bottom:0;content:\"\";display:block;height:100%;left:0;position:absolute;width:100%}.v-text-shadow--1[data-v-3f41ce58]{text-shadow:0 0 7px #3e2b2e}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
